export function getFirstLetter(text: string | undefined) {
  if (!text) {
    return '';
  }
  return text.trim().substring(0, 1).toUpperCase();
}

export const truncate = (text: string, length: number) =>
  text.length > length ? `${text.substring(0, length)}...` : text;
